import styles from "./Date.module.css"
import { Calendar } from 'lucide-react';
import { formatDate } from "../../../../../utils/calendar";
import { useTranslation } from "react-i18next";
/**
* Props for the DateInput component.
*/ 
interface DateInputProps {
    selectedDates: string[]; // Selected dates
}
/**
* A date input component.
*
* @param props DateInputProps
* @param {string[]} props.selectedDates - Selected dates
* @returns TSX.Element
*/
const DateInput = ({ selectedDates} : DateInputProps) => {
    const { t } = useTranslation(); // Translation
    return(
        <>
            <div className={styles.DateInput}>
                <div className={styles.DateInputHeader}>
                    <div className={styles.DateInputHeaderIcon}>
                        <Calendar/>
                    </div>
                    <div className={styles.DateInputHeaderText}>
                        <p className={styles.InputTitle}>{t("checkout.steps.2.inputs.date")}</p>
                        <p className={styles.InputSelected}>{selectedDates.length !== 0 ? selectedDates.map(d=>formatDate(d)).join(" | "): ""}</p>
                    </div>
                </div>
            </div> 
        </>
    )
}

export default DateInput;